import ContentLoader from 'react-content-loader';
import *as React from 'react';

export const ActivityTitleFilterLoader =props=>{
        return(<>
            {props.count && props.count > 0 && (
                          Array.from({ length: props.count }, (_, i) => (
                            <ContentLoader 
                            height={180}
                            key={i+1}
                            width={400}
                            speed={2}>
                            <rect x="0" y="0" rx="4" ry="4" width="70" height="12" />            
                            <rect x="0" y="45" rx="4" ry="4" width="20" height="20" /> 
                            <rect x="0" y="85" rx="4" ry="4" width="20" height="20" /> 
                            <rect x="0" y="125" rx="4" ry="4" width="20" height="20" />                             
                            <rect x="36" y="45" rx="4" ry="4" width="200" height="12" /> 
                            <rect x="36" y="85" rx="4" ry="4" width="200" height="12" /> 
                            <rect x="36" y="125" rx="4" ry="4" width="200" height="12" />
                        </ContentLoader>
                          ))
                      )}</>)
    }